import { brackyAnimations as originalBrackyAnimations } from "../madness/BrackyAvatar"

// Re-export the global animation controller so landing components can import from this module
export const brackyAnimations = originalBrackyAnimations
